export enum NetworkErrors {
  NoAccessToken = "No access token set",
  NoSmtzAuthToken = "No smtzAuth token returned in smeetz-boffice response",
}

export enum AuthErrors {
  InvalidCredentials = "Invalid Credentials",
  NoSmtzAuthToken = "Could not obtain gql auth token",
  UnknownError = "An unknown error occurred",
}
